/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveEmail } from '../../../../../../app/page/page-storage/sessions/sessions.actions';
import { sessionSelectors } from '../../../../../../app/resource/session/session.selectors';
import { meetingSimpleSelectors } from '../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { useSelectWithParams } from '../../../../../../utils/selector.utils';

import { INonMeetingUsersProps } from './types';
import { hasUserElevatedPrivilegesDuringSession } from '../../../../../../utils/user.utils';

export const NonMeetingUsers: FunctionComponent<INonMeetingUsersProps> = ({ sessionId, loggedUserId }) => {
  const session = useSelectWithParams(sessionSelectors.selectResourceById, sessionId);
  const meetingId = session?.meetingId;
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId ?? '');

  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [emails, setEmails] = useState(session ? session.nonMeetingMembers : ([] as string[]));
  const dispatch = useDispatch();

  useEffect(() => {
    setEmails(session ? session.nonMeetingMembers : ([] as string[]));
  }, [session]);

  useEffect(() => {
    const checkEmail = () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setIsValidEmail(emailRegex.test(email));
    };
    checkEmail();
  }, [email]);

  const onSubmit = useCallback(() => {
    setEmails([...emails, email]);
    dispatch(saveEmail(sessionId, email));
    setEmail('');
    setIsValidEmail(false);
  }, [dispatch, email, emails, sessionId]);

  const hasElevatedPrivileges = hasUserElevatedPrivilegesDuringSession(loggedUserId, session, meeting);

  return (
    <div className="row mb-25 mt-3 ml-1" style={{ width: '35%' }}>
      <div className="col-12">
        <div className="panel" style={{ height: '100%' }}>
          <div className="panel-header no-border">
            <h2 className="bold">Email Non-Meeting Users</h2>
          </div>
          <div className="panel-body pt-0 ho-hover" style={{ height: '80%' }}>
            <div className="border-radius-1 lightGray-bg p-2" style={{ height: '100%' }}>
              <div className="col-9" style={{ height: '100%', width: '100%', maxWidth: '100%', padding: 0 }}>
                <div className="panel panel-body w100 p-0 no-hober" style={{ height: '100%' }}>
                  {hasElevatedPrivileges && (
                    <div style={{ padding: '15px 15px 0 15px' }}>
                      <div className="field-container">
                        <input
                          id={'description'}
                          name={'description'}
                          placeholder="Enter Email"
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                        />
                        <button
                          type="button"
                          style={
                            isValidEmail
                              ? { position: 'relative', float: 'right' }
                              : { pointerEvents: 'none', position: 'relative', float: 'right' }
                          }
                          className={
                            isValidEmail
                              ? 'btn btn-sm green-bg small-submit comment-submit'
                              : 'btn btn-sm darkGray-bg small-submit comment-submit'
                          }
                          onClick={onSubmit}
                        >
                          ADD
                        </button>
                      </div>
                    </div>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', height: '170px' }}>
                    {emails &&
                      emails.map((email) => (
                        <div
                          key={email}
                          style={{ display: 'flex', alignItems: 'center', marginLeft: '20px', paddingTop: '15px' }}
                        >
                          <span
                            style={{
                              backgroundColor: '#1bc3a7',
                              borderRadius: '10px',
                              width: '10px',
                              height: '10px',
                              marginRight: '5px',
                            }}
                          />
                          <div>{email}</div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
